export const TEXT_BUTTON_TITLE = 'text-button-title';
